module.exports = __webpack_public_path__ + "static/6-0ee474d656d82adb6575f99b0cf13a65.jpg";